import { __exports as u } from "./contact-channels206.js";
import { __require as d } from "./contact-channels207.js";
import { __require as p } from "./contact-channels208.js";
var v;
function R() {
  if (v) return u;
  v = 1, Object.defineProperty(u, "__esModule", { value: !0 }), u.default = E;
  var s = d(), t = p(), c = ["checked", "value"], l = ["input", "select", "textarea"], T = {
    reset: !0,
    submit: !0
  };
  function E(r, P) {
    r === void 0 && (r = {});
    var e = {}, a = !!(r.type && T[r.type]);
    for (var o in r) {
      var n = r[o];
      if ((0, s.isCustomAttribute)(o)) {
        e[o] = n;
        continue;
      }
      var O = o.toLowerCase(), i = _(O);
      if (i) {
        var f = (0, s.getPropertyInfo)(i);
        switch (c.includes(i) && l.includes(P) && !a && (i = _("default" + O)), e[i] = n, f && f.type) {
          case s.BOOLEAN:
            e[i] = !0;
            break;
          case s.OVERLOADED_BOOLEAN:
            n === "" && (e[i] = !0);
            break;
        }
        continue;
      }
      t.PRESERVE_CUSTOM_ATTRIBUTES && (e[o] = n);
    }
    return (0, t.setStyleProp)(r.style, e), e;
  }
  function _(r) {
    return s.possibleStandardNames[r];
  }
  return u;
}
export {
  R as __require
};
//# sourceMappingURL=contact-channels157.js.map
